<template>
    <rkm-area
        no-margin-top
        title="Procedimentos clínicos"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.plano.procedimentosClinicos"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="8">
                                <Item
                                    :get-value="() => `${formatProcedimento(item.procedimento.codigo)} - ${item.procedimento.nome}`"
                                    label="Procedimento"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.quantidade"
                                    label="Quantidade"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.automatico ? 'Sim' : 'Não'"
                                    label="Automático"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template #collapse="{item}">
                        <rkm-row class="p-2">
                            <rkm-col>
                                <Item :get-value="() => item.observacao" />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="item.materiais && item.materiais.length" class="p-2">
                            <rkm-col>
                                <rkm-table
                                    :fields="fieldsMateriais"
                                    :items="item.materiais"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot:cell(lotes)="row">
                                        <div :key="lote" v-for="lote in row.item.lotes">
                                            {{ lote }}
                                        </div>
                                    </template>
                                </rkm-table>
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Item},
    data: () => ({
        fieldsMateriais: [
            {key: 'descricao', label: 'Material', sortable: true},
            {key: 'quantidade', label: 'Quantidade', sortable: true, class: 'col-min text-center'},
            {key: 'lotes', label: 'Lote', sortable: true},
        ],
    }),
    mixins: [formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>